import { createAsyncThunk } from '@reduxjs/toolkit';

import { ROUTE as AUTH_USER_ME, Params as MeParams, Result as MeResult } from '@api/routes/auth/user/me/params';
import { ApiResponse } from '@api/types/api-response';

import { api } from 'src/utils/api';

export const me = createAsyncThunk<ApiResponse<MeResult>, MeParams, { rejectValue: string }>(
  'user/me',
  async (_data, { rejectWithValue }) => {
    try {
      const response = await api.sendRequest<MeResult>({ url: AUTH_USER_ME, method: 'GET' });

      if (response.success) {
        return response;
      }

      throw new Error(response.error.message as string);
    } catch (e) {
      return rejectWithValue((e as Error).message);
    }
  }
);
